__webpack_require__.p = "https://design-system.ads.sportradar.com/";